/* Generated. This file cannot be edited directly. Please check codegen.ts for configuration. */
// @ts-nocheck

import * as Apollo from '@apollo/client'

import { gql } from '@apollo/client'
import * as Types from '../../../graphql/src/lib/graphql/generated/types'

const defaultOptions = {} as const
export type OverwatchMapOperatingAreasQueryVariables = Types.Exact<{
  regionId: Types.Scalars['ID']['input']
}>

export type OverwatchMapOperatingAreasQuery = {
  __typename?: 'Query'
  operatingAreasByRegionId: Array<{
    __typename?: 'OperatingArea'
    id: string
    name: string
    geometry: string
  }>
}

export const OverwatchMapOperatingAreasDocument = gql`
    query OverwatchMapOperatingAreas($regionId: ID!) {
  operatingAreasByRegionId(regionId: $regionId) {
    id
    name
    geometry
  }
}
    `

/**
 * __useOverwatchMapOperatingAreasQuery__
 *
 * To run a query within a React component, call `useOverwatchMapOperatingAreasQuery` and pass it any options that fit your needs.
 * When your component renders, `useOverwatchMapOperatingAreasQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOverwatchMapOperatingAreasQuery({
 *   variables: {
 *      regionId: // value for 'regionId'
 *   },
 * });
 */
export function useOverwatchMapOperatingAreasQuery(
  baseOptions: Apollo.QueryHookOptions<
    OverwatchMapOperatingAreasQuery,
    OverwatchMapOperatingAreasQueryVariables
  > &
    (
      | { variables: OverwatchMapOperatingAreasQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    OverwatchMapOperatingAreasQuery,
    OverwatchMapOperatingAreasQueryVariables
  >(OverwatchMapOperatingAreasDocument, options)
}
export function useOverwatchMapOperatingAreasLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    OverwatchMapOperatingAreasQuery,
    OverwatchMapOperatingAreasQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    OverwatchMapOperatingAreasQuery,
    OverwatchMapOperatingAreasQueryVariables
  >(OverwatchMapOperatingAreasDocument, options)
}
// @ts-ignore
export function useOverwatchMapOperatingAreasSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    OverwatchMapOperatingAreasQuery,
    OverwatchMapOperatingAreasQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  OverwatchMapOperatingAreasQuery,
  OverwatchMapOperatingAreasQueryVariables
>
export function useOverwatchMapOperatingAreasSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        OverwatchMapOperatingAreasQuery,
        OverwatchMapOperatingAreasQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  OverwatchMapOperatingAreasQuery | undefined,
  OverwatchMapOperatingAreasQueryVariables
>
export function useOverwatchMapOperatingAreasSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        OverwatchMapOperatingAreasQuery,
        OverwatchMapOperatingAreasQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    OverwatchMapOperatingAreasQuery,
    OverwatchMapOperatingAreasQueryVariables
  >(OverwatchMapOperatingAreasDocument, options)
}
export type OverwatchMapOperatingAreasQueryHookResult = ReturnType<
  typeof useOverwatchMapOperatingAreasQuery
>
export type OverwatchMapOperatingAreasLazyQueryHookResult = ReturnType<
  typeof useOverwatchMapOperatingAreasLazyQuery
>
export type OverwatchMapOperatingAreasSuspenseQueryHookResult = ReturnType<
  typeof useOverwatchMapOperatingAreasSuspenseQuery
>
export type OverwatchMapOperatingAreasQueryResult = Apollo.QueryResult<
  OverwatchMapOperatingAreasQuery,
  OverwatchMapOperatingAreasQueryVariables
>
